// extracted by mini-css-extract-plugin
export default {"p_tye":"ecf3f356ef","slcted":"_06f3df0a15","slc_color":"_5a56540dfb","item_p":"f4d7f41aae","r0":"f7fe569cb3"};